import { FaMoneyCheckAlt, FaTree, FaHiking } from 'react-icons/fa'
export const services = [
  {
    id: 1,
    icon: <FaMoneyCheckAlt />,
    title: 'saving money',
    text:
      '  Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.',
  },
  {
    id: 2,
    icon: <FaTree />,
    title: 'endless hiking',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
  },
  {
    id: 3,
    icon: <FaHiking />,
    title: 'amazing comfort',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
  },
]
